<template>
  <v-card flat height="100%">
    <v-card-title>
      Campaign {{ campaign.name }}
    </v-card-title>
    <v-card-text>
      <!-- Campaign Stats -->
      <campaign-lifetime-stats
        chart-prefix="lifetime"
        :dealer="dealer"
        :campaign="campaign"
      />
      <!--
        NOTE using key on the campaign-activity-stats to prevent caching
        and force a reload on the chart
      -->
      <campaign-activity-stats
        :key="'cas-' + campaign.id"
        chartPrefix="campaign"
        :dealer="dealer"
        :campaign="campaign"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import { CampaignActivityStats, CampaignLifetimeStats } from '@/components/charts'
import ConversionStatsCard from '../conversionStats/ConversionStatsCard'
import * as R from 'ramda'

export default {
  name: 'email-campaign-stats',
  props: {
    emailCampaignId: {
      type: [Number, String],
      required: false,
      default: null
    }
  },
  data () {
    return {
    }
  },
  components: {
    [CampaignActivityStats.name]: CampaignActivityStats,
    [CampaignLifetimeStats.name]: CampaignLifetimeStats,
    [ConversionStatsCard.name]: ConversionStatsCard
  },
  computed: {
    ...mapState('DealerStore', { dealer: 'dealer' }),
    ...mapState('EmailCampaignStore', { campaign: 'emailCampaign' })
  },
  watch: {
    dealer () {
      // redirect to index because the campaign does not belong to the dealer....
      this.$router.push({ name: 'email_campaigns_path' })
    },
    emailCampaignId: {
      immediate: true,
      handler (newVal, oldVal) {
        this.loadCampaign()
      }
    }
  },
  methods: {
    loadCampaign () {
      const loadedCampaignId = R.prop('id', this.emailCampaign)
      if (loadedCampaignId !== this.emailCampaignId) {
        this.$store
          .dispatch('EmailCampaignStore/getEmailCampaign', {
            id: this.emailCampaignId
          })
          .then(emailCampaign => {
            this.$logger.trace('Email Campaign Loaded!')
          })
          .catch(error => {
            this.$logger.error('Error loading EmailCampaign', error.message)
            this.$flash({
              showClose: true,
              message: 'Error Loading. Reload to try again',
              type: 'error',
              duration: 0
            })
          })
      }
    }
  }
}
</script>
